module.exports = __webpack_public_path__ + "static/media/logo.8c352a8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/logo.svg
// module id = 95
// module chunks = 0